module.exports = __webpack_public_path__ + "img/ea58301.jpg";